import { render, staticRenderFns } from "./ElaborazioniBatchElaborazioniListComponent.vue?vue&type=template&id=0e85769e"
import script from "./ElaborazioniBatchElaborazioniListComponent.vue?vue&type=script&lang=js"
export * from "./ElaborazioniBatchElaborazioniListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports